import React from 'react';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import {


} from 'react-router-dom';
import { compose } from 'redux';
import {
  LayoutWrapperMain,
  Page,
  PaymentManagement,
} from '../../components';
import config from '../../config';

interface Props {
  scrollingDisabled: boolean,
  // from  
  // from injectIntl
  intl: any,
}

const PaymentManagementComponent: React.FC<Props> = (props: Props) => {
  const {
    intl,
    scrollingDisabled,
  } = props;
  const { siteTitle } = config;
  const schemaTitle = intl.formatMessage(
    { id: 'PaymentManagement.page.title' },
    { siteTitle },
  );
  return (
    <Page
      title={schemaTitle}
      scrollingDisabled={scrollingDisabled}
      schema={{
        '@context': 'http://schema.org',
        '@type': 'WebPage',
        name: schemaTitle,
      }}
    >
      <LayoutWrapperMain>
        <div>
          <PaymentManagement />
        </div>
      </LayoutWrapperMain>
    </Page>
  );
};

const mapStateToProps = () => ({
});

const mapDispatchToProps = () => ({
});

const PaymentManagementPage = compose(

  connect(mapStateToProps, mapDispatchToProps),
  injectIntl,
)(PaymentManagementComponent);

export default PaymentManagementPage;
